<ng-container *transloco="let t">
  <ISidebarLayout [collapsed]="isCollapsed()">
    <ng-container sidebarHeader>
      <a class="block h-full py-2" routerLink="/dashboard" queryParamsHandling="merge">
        <app-logo></app-logo>
      </a>
      <button
        iButton
        variant="ghost"
        size="sm"
        [iTooltip]="t('page-title.collapse_sidebar')"
        iTooltipPlacement="right-center"
        (click)="isCollapsed.set(!isCollapsed())"
      >
        <IIcon name="sidebarLeft" />
      </button>
    </ng-container>
    <ng-container sidebarBody>
      @for (section of menu(); track section.label) {
        <div class="flex min-w-0 flex-col gap-2 px-4">
          <div class="min-w-0">
            <div class="type-label text-muted-foreground truncate">{{ t(section.label) }}</div>
            <ul class="min-w-0 pt-2 pl-2">
              @for (menuItem of section.children; track menuItem.label) {
                <ISidebarItem
                  [item]="menuItem"
                  [selected]="selectedItemId() === menuItem.id"
                  [isOpen]="openedItemId() === menuItem.id"
                  (itemClick)="toggleItem(menuItem.id)"
                />
                @if (menuItem.children) {
                  <IAccordion [isOpen]="openedItemId() === menuItem.id">
                    <ul class="ml-4 min-w-0 border-l pl-2">
                      @for (child of menuItem.children; track child.label) {
                        <ISidebarItem [item]="child" [selected]="selectedItemId() === child.id" />
                      }
                    </ul>
                  </IAccordion>
                }
              }
            </ul>
          </div>
        </div>
      }
    </ng-container>
    <ng-container sidebarFooter>
      <app-onboarding-cta [onlyButton]="false" />
      <div class="flex min-w-0 flex-col gap-1 overflow-hidden border-t p-4">
        <button [iDropdownMenuTrigger]="settingsMenu" placement="right-end">
          <ISidebarItem [item]="settingsItem" />
        </button>

        <ng-template #settingsMenu>
          <IDropdownMenu class="w-62.5">
            <a iDropdownMenuItem routerLink="/profile">
              <IIcon name="user" />
              <span>{{ t("page-title.my_profile") }}</span>
            </a>
            <a iDropdownMenuItem routerLink="/accounts">
              <IIcon name="users" />
              <span>{{ t("page-title.accounts") }}</span>
            </a>
            @if (!productTour()) {
              <a iDropdownMenuItem routerLink="/user-management">
                <IIcon name="userCog" />
                <span>{{ t("page-title.user_management") }}</span>
              </a>
            }
            <a iDropdownMenuItem routerLink="/activities">
              <IIcon name="newspaper" />
              <span>{{ t("page-title.activities") }}</span>
            </a>
            <IDropdownMenuSeparator />
            @if (hasBillingAccess() && !productTour()) {
              <a iDropdownMenuItem routerLink="/billing">
                <IIcon name="creditCard" />
                <span>{{ t("page-title.billing") }}</span>
              </a>
            }
            @if (hasAccessToDataWarehouse()) {
              <a iDropdownMenuItem routerLink="/data-warehouse">
                <IIcon name="database" />
                <span>{{ t("page-title.data_warehouse") }}</span>
              </a>
            }
            <a iDropdownMenuItem [href]="releaseNotesUrl" target="_blank">
              <IIcon name="star" />
              <span>{{ t("page-title.release_notes") }}</span>
            </a>
            <IDropdownMenuSeparator />
            <button iDropdownMenuItem (click)="logout()">
              <IIcon name="logout" />
              <span>{{ t("page-title.logout") }}</span>
            </button>
          </IDropdownMenu>
        </ng-template>

        @if (boardType === BoardType.M19 || whitelabelContactUsLink) {
          <ISidebarItem [item]="helpItem" />
        }
      </div>
    </ng-container>
  </ISidebarLayout>
</ng-container>
